var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-detail" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("whatsapp_business_api.wpBussChannelDetail"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("whatsapp_business_api.manageChannelDetail"))),
        ]),
      ]),
      _vm._v(" "),
      _vm.shouldShowIframe
        ? [
            _c(
              "div",
              { staticClass: "onboarding-wrapper" },
              [
                _c(
                  "SupsisButton",
                  {
                    staticClass: "integration-button",
                    attrs: { type: "primary", large: "", primary: "" },
                    on: { click: _vm.openOnboardingLink },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("Whatsapp Entegrasyonunu Yap")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    staticClass: "integration-button",
                    attrs: { xlarge: "", ghost: "", icon: "help" },
                    on: { click: _vm.connectSupportTeamRequest },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("Yardım Al")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("a-alert", {
                  staticClass: "mt-4",
                  attrs: {
                    message: "Bilgilendirme",
                    description:
                      "Eğer WhatsApp hattınızı başarılı bir şekilde tanımladıysanız, bu ekranın güncellenmesi biraz zaman alabilir.",
                    type: "info",
                    "show-icon": "",
                  },
                }),
              ],
              1
            ),
          ]
        : [
            _c("a-form", [
              _c(
                "div",
                { staticClass: "form-wrapper" },
                [
                  _c(
                    "a-alert",
                    { attrs: { message: "Webhook Address", type: "success" } },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "description" }, slot: "description" },
                        [
                          _c("div", { staticClass: "webhook-info" }, [
                            _c(
                              "span",
                              [
                                _c("a-icon", {
                                  attrs: { type: "copy" },
                                  on: { click: _vm.copyWebhookAddress },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v("OLD: " + _vm._s(_vm.getWebhookAddress())),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "webhook-info" }, [
                            _c(
                              "span",
                              [
                                _c("a-icon", {
                                  attrs: { type: "copy" },
                                  on: {
                                    click: function () {
                                      return _vm.copyWebhookAddress(true)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v("NEW: https://webhook.supsis.ai/waba"),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-wrapper" },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.$t("whatsapp_business_api.channelName"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("a-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.$t(
                            "whatsapp_business_api.channelName"
                          ),
                          name: "channelName",
                        },
                        model: {
                          value: _vm.clone.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.clone, "name", $$v)
                          },
                          expression: "clone.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-wrapper" },
                    [
                      _c("label", [_vm._v("API Key ")]),
                      _vm._v(" "),
                      _c("a-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: { placeholder: "API Key ", name: "apiKey" },
                        on: { focus: _vm.showWarning },
                        model: {
                          value: _vm.clone.payload.apiKey,
                          callback: function ($$v) {
                            _vm.$set(_vm.clone.payload, "apiKey", $$v)
                          },
                          expression: "clone.payload.apiKey",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-wrapper" },
                    [
                      _c("label", [_vm._v("App ID")]),
                      _vm._v(" "),
                      _c("a-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: { placeholder: "App ID ", name: "appId" },
                        on: { focus: _vm.showWarning },
                        model: {
                          value: _vm.clone.payload.appId,
                          callback: function ($$v) {
                            _vm.$set(_vm.clone.payload, "appId", $$v)
                          },
                          expression: "clone.payload.appId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-wrapper" },
                    [
                      _c("label", [_vm._v("App Name")]),
                      _vm._v(" "),
                      _c("a-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: { placeholder: "App Name ", name: "appName" },
                        on: { focus: _vm.showWarning },
                        model: {
                          value: _vm.clone.payload.appName,
                          callback: function ($$v) {
                            _vm.$set(_vm.clone.payload, "appName", $$v)
                          },
                          expression: "clone.payload.appName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-wrapper" },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("whatsapp_business_api.phoneNumberE164")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("a-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.$t(
                            "whatsapp_business_api.phoneNumberE164Place"
                          ),
                          name: "phoneNumber",
                        },
                        on: { focus: _vm.showWarning },
                        model: {
                          value: _vm.clone.payload.phoneNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.clone.payload, "phoneNumber", $$v)
                          },
                          expression: "clone.payload.phoneNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("ChannelForwardSetting", { attrs: { channel: _vm.clone } }),
            _vm._v(" "),
            _c("div", { staticClass: "form-footer" }, [
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "pr-confirm-btn",
                      attrs: { type: "primary", disabled: _vm.loading },
                      on: { click: _vm.handleSave },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("message.update")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }